import { render, staticRenderFns } from "./IcoBookPlus.vue?vue&type=template&id=0144af4a"
import script from "./IcoBookPlus.vue?vue&type=script&lang=js"
export * from "./IcoBookPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports